import './Whatsapp.css';

const Whatsapp = () => (
  <a
    className="botao_wpp botao_wpp--low"
    href="https://wa.me/555491556023"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chame-nos no WhatsApp"
  >
    <img className="botao_wpp_ico" src="/images/icons/ico whatsapp 2.png" alt="Ícone do WhatsApp" />
  </a>
);

export default Whatsapp;
